import type { PropsWithChildren } from "react";

import { IconButton } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { FilterSearchBox } from "../FilterSearchBox/FilterSearchBox";

import { StyledOverlayHeader } from "./styles";

type OverlayHeaderProps = PropsWithChildren<{
    onSearchChange: (query: string) => void;
    onSearchFocus?: VoidFunction;
    onClose: VoidFunction;
}>;

export const OverlayHeader = ({ children, onSearchChange, onSearchFocus, onClose }: OverlayHeaderProps) => {
    return (
        <StyledOverlayHeader>
            {children}

            <Flex
                alignItems="center"
                flexShrink={0}
            >
                <FilterSearchBox
                    onChange={onSearchChange}
                    onFocus={onSearchFocus}
                />

                <IconButton
                    iconName="clear"
                    type="flat"
                    dataAutomation="expanded-filters.close-button"
                    onClick={onClose}
                />
            </Flex>
        </StyledOverlayHeader>
    );
};
